((root) => {
  const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });
  const sizes = ['xxs','xs','s','sm','m','ml','l','lxl','xl','xxl','xxxl','4xl','5xl','6xl','7xl','8xl'];
  function sizeRank(value) {
    const text = value.toLowerCase().split('·')[0].trim();
    if (/plus/.test(text)) return 9001;
    if (/one.?size|universal|o\/s/.test(text)) return 9000;
    const key = text.replace(/[\s/\-]/g, '');
    const known = sizes.indexOf(key);
    if (known >= 0) return known;
    const number = text.match(/\d+(?:[.,]\d+)?/);
    return number ? 200 + Number(number[0].replace(',', '.')) : 5000;
  }
  function compare(kind, a, b) {
    if (kind === 'size') return sizeRank(a) - sizeRank(b) || collator.compare(a,b);
    if (kind === 'price') {
      const lower = value => /^(under|below|up to|<|≤)/i.test(value.trim()) ? 0 : Number(value.replace(/[^\d.,]/g, ' ').trim().split(/\s+/)[0]?.replace(',', '.')) || 0;
      return lower(a) - lower(b) || collator.compare(a,b);
    }
    return collator.compare(a,b);
  }
  root.SinroomFilterOrder = { compare };
  if (typeof module !== 'undefined' && module.exports) module.exports = { compare };
  if (typeof document === 'undefined') return;
  function initialise(scope = document) {
    scope.querySelectorAll('[data-catalog-toolbar]').forEach(toolbar => {
      if (toolbar.dataset.initialised) return;
      toolbar.dataset.initialised = 'true';
      const form = toolbar.querySelector('[data-catalog-form]');
      const facets = [...toolbar.querySelectorAll('[data-shop-filter]')];
      const close = () => facets.forEach(facet => { facet.open = false; });
      const place = facet => {
        const summary = facet.querySelector('summary');
        const panel = facet.querySelector('.shop-filter-panel');
        const anchor = summary.getBoundingClientRect();
        facet.dataset.align = anchor.left + Math.min(360, innerWidth - 40) > innerWidth - 20 ? 'end' : 'start';
        const below = innerHeight - anchor.bottom - 16;
        const above = anchor.top - 16;
        const up = below < 180 && above > below;
        facet.dataset.up = String(up);
        panel.style.setProperty('--panel-max', `${Math.max(120, Math.min(380, up ? above : below))}px`);
      };
      toolbar.querySelectorAll('[data-sort-values]').forEach(list => {
        if (list.dataset.sortValues === 'availability') return;
        const choices = [...list.querySelectorAll(':scope > [data-filter-value]')];
        choices.sort((a,b) => compare(list.dataset.sortValues,a.dataset.filterValue,b.dataset.filterValue)).forEach(choice => list.append(choice));
      });
      facets.forEach(facet => {
        const summary = facet.querySelector('summary');
        summary.addEventListener('click', () => { if (!facet.open) facets.forEach(other => { if (other !== facet) other.open = false; }); });
        facet.addEventListener('toggle', () => { if (facet.open) { facets.forEach(other => { if (other !== facet) other.open = false; }); place(facet); } });
        facet.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); facet.open = false; summary.focus(); } });
      });
      document.addEventListener('pointerdown', event => { if (toolbar.isConnected && !toolbar.contains(event.target)) close(); });
      addEventListener('resize', () => facets.filter(facet => facet.open).forEach(place));
      const min = form.querySelector('[name="filter.v.price.gte"]');
      const max = form.querySelector('[name="filter.v.price.lte"]');
      const validatePrice = () => { if (max) max.setCustomValidity(min?.value && max.value && Number(min.value) > Number(max.value) ? form.dataset.priceError : ''); };
      min?.addEventListener('input',validatePrice);max?.addEventListener('input',validatePrice);
      const apply = () => {
        validatePrice();
        if (!form.reportValidity()) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      };
      toolbar.addEventListener('click', event => {
        if (event.target.closest('[data-apply-shop-filter]')) apply();
      });
      form.querySelector('[data-catalog-sort]')?.addEventListener('change', apply);
      form.addEventListener('invalid', event => {
        const facet = event.target.closest('[data-shop-filter]');
        if (facet) { facet.open = true; place(facet); }
      },true);
      const query = () => {
        const params = new URLSearchParams();
        for (const [key,value] of new FormData(form)) if (String(value).trim() !== '') params.append(key,value);
        return params;
      };
      form.addEventListener('submit', event => {
        event.preventDefault();validatePrice();if (!form.reportValidity()) return;if (root.SinroomCatalogUnion?.submit?.(toolbar)) return;
        const target = new URL(form.action);target.search = query().toString();target.hash = '';location.assign(target.href);
      });
      toolbar.querySelectorAll('.shop-filter-tag a').forEach(link => link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();validatePrice();if (!form.reportValidity()) return;
        const target = new URL(link.href);target.search = query().toString();target.hash = '';location.assign(target.href);
      }));
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})(typeof window === 'undefined' ? globalThis : window);
